/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/styles';
import { object, string } from 'prop-types';
import { Container, Grid } from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';

const styles = (theme) => {
    const { breakpoints: { maxWidth, minWidth }, palette = {}, typography: { cms = [] } } = theme;
    return {
        footerBannerContainer: {
            '&.footer-banner-wrapper': {
                backgroundColor: palette.footerBanner,
                color: palette.white,
                padding: '48px 0 70px 0',
                [theme.breakpoints.between(minWidth?.small_screen_down, maxWidth?.medium_screen_down)]: {
                    padding: '30px 0 40px 0',
                },
                [theme.breakpoints.down(maxWidth?.small_screen_up)]: {
                    paddingBottom: '10px',
                },
                '& .MuiGrid-container': {
                    '&:last-child': {
                        '& .banner-inner-wrapper': {
                            maxWidth: '280px',
                        },
                    },
                },
                '& .banner-wrapper': {
                    '&:first-child': {
                        '& .banner-inner-wrapper': {
                            maxWidth: '335px',
                        },
                    },
                    '&:nth-child(2)': {
                        '& .banner-inner-wrapper': {
                            maxWidth: '250px',
                        },
                    },
                    '&:last-child': {
                        '& .banner-inner-wrapper': {
                            maxWidth: '280px',
                        },
                    },
                    flex: '0 0 33.3333%',
                    maxWidth: '33.3333%',
                    textAlign: 'center',
                    '& .banner-inner-wrapper': {
                        margin: '0 auto',
                        '& svg': {
                            paddingBottom: '28px',
                        },
                        '& .title': {
                            fontWeight: '600',
                            lineHeight: '1.5',
                            margin: 0,
                        },
                        '& .description': {
                            lineHeight: '1.5',
                            margin: 0,
                        },
                    },
                    [theme.breakpoints.down(maxWidth?.small_screen_up)]: {
                        paddingBottom: '30px',
                        flex: '0 0 100%',
                        maxWidth: '100%',
                        '& .bannerInnerWrapper': {
                            '& img': {
                                paddingBottom: '20px',
                            },
                            '& svg': {
                                paddingBottom: '20px',
                            },
                            '& .title': {
                                lineHeight: '1.5',
                            },
                            '& .description': {
                                lineHeight: '1.5',
                            },
                        },
                    },
                },
            },
            '&.footer-banner-new-wrapper': {
                backgroundColor: palette.footerBannerNew,
                color: palette.black,
                '& .bannerWrapper': {
                    '& .bannerInnerWrapper': {
                        '& svg': {
                            '& path': {
                                fill: palette.footerBannerIcon,
                            },
                        },
                        '& .title': {
                            fontWeight: 'unset !important',
                            lineHeight: '1.5',
                            fontFamily: cms[5],
                            letterSpacing: '1.8px',
                            fontSize: 30,
                        },
                        '& .description': {
                            letterSpacing: '0.96px',
                            lineHeight: '1.5',
                            marginBottom: 0,
                        },
                    },
                    [theme.breakpoints.down(maxWidth?.small_screen_up)]: {
                        padding: '0px 30px 30px',
                    },
                },
            },
        },
    };
};

const FooterBanner = ({ classes, data }) => (
    <div className={`container-fluid footer-banner-wrapper ${classes.footerBannerContainer}`}>
        <Container>
            <Grid container direction="row">
                {ReactHtmlParser(data)}
            </Grid>
        </Container>
    </div>
);

FooterBanner.propTypes = {
    classes: object.isRequired,
    data: string.isRequired,
};

export default withStyles(styles)(FooterBanner);
